import { Form } from "@repo/ui";
import { useForm } from "react-hook-form";
import FormInput from "ui/Input";

export default function RouteDetails({ route }) {
  const form = useForm({ defaultValues: { ...route } });
  const generalProps = { errors: form.formState.errors, control: form.control };
  return (
    <div className="form-container" style={{ margin: 0 }}>
      <Form {...form}>
        <form className="custom-form-v2">
          <h1 className="text-lg font-medium">Route Details</h1>
          {/* <div className="flex flex-row justify-end w-full my-2">
            <Link>
              <Button variant={"secondary"}>Open Records</Button>
            </Link>
          </div> */}
          <div className="dialogue-form-row mt-4">
            <FormInput
              {...generalProps}
              name="description"
              label="Description"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="routeNo"
              label="Route No"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="cashCenter"
              label="Cash Center"
              hideIcons
              inputProps={{ readOnly: true }}
            />

            <FormInput
              {...generalProps}
              name="office"
              label="Office"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="requiredTeamMembers"
              label="Team Members"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="routeArea"
              label="Route Area"
              hideIcons
              inputProps={{ readOnly: true }}
            />
            <FormInput
              {...generalProps}
              name="status"
              label="Status"
              hideIcons
              inputProps={{ readOnly: true }}
            />
          </div>
        </form>
      </Form>
    </div>
  );
}
